// グループ番号・名称付きオプションの表記ゆれ吸収。
// 加工指示/品番マスタで同じ判定になるよう、実装は1か所に集約する(本文は Kakousiji.js から移設)。
//
// normalizeGroupNo は "Group1" / "1" / "01" をすべて "01" に寄せる。
// 品番マスタ側の旧実装は trim するだけだったため、採番済みグループの突合に失敗していた。

export function normalizeGroupNo(value) {
    const raw = String(value ?? "").trim();
    if (raw === "") return "";
    const compact = raw.replace(/\s+/g, "");
    const labelMatch = compact.match(/^Group0*(\d+)$/i);
    if (labelMatch) return String(labelMatch[1] ?? "").padStart(2, "0");
    const codeMatch = compact.match(/^0*(\d+)$/);
    if (codeMatch) return String(codeMatch[1] ?? "").padStart(2, "0");
    return compact;
}

export function groupNoToLabel(value) {
    const no = normalizeGroupNo(value);
    if (no === "") return "";
    const parsed = Number(no);
    if (!Number.isFinite(parsed) || parsed <= 0) return no;
    return `Group${parsed}`;
}

export function formatNamedOptionLabel(code, name) {
    const nextCode = String(code ?? "").trim();
    const nextName = String(name ?? "").trim();
    if (nextCode === "") return "";
    return nextName === "" ? nextCode : `${nextCode}:${nextName}`;
}
